import dayjs, { Dayjs } from 'dayjs';

export const parseTimeStringToDayjs = (
  timeStr?: string | null,
  baseDate?: Dayjs | null
): Dayjs | null => {
  if (!timeStr) return null;

  const [hours, minutes] = timeStr.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) return null;

  return (baseDate ?? dayjs())
    .hour(hours)
    .minute(minutes)
    .second(0)
    .millisecond(0);
};
